<template>
  <div :class="componentClassName">
    <a-page-heading>連絡先</a-page-heading>
    <m-section variant="fullpage">
      <m-action-card
        id="contactTitle"
        :title="titleText"
        no-header-margin
        :header-border="true"
        icon="upload"
        :narrow-body="true"
      >
        <a-select-field id="pulldownList" v-model="selectedFormat" :options="pulldownList" />
        <form class="t-phone-book-add-by-uploading-file__form" @submit.prevent="handleFormSubmit">
          <template v-if="btnText === '登録' && selectedFormat === 'simpleCsv'">
            <a-text
              class="t-phone-book-add-by-uploading-file__description"
              text="下のボタンからダウンロードしたテンプレートCSVファイルに登録したい連絡先情報を入力してアップロードしてください。"
            />
            <li>・ 姓、名、フリガナ（姓）、フリガナ（名）、電話番号は必須項目となります。</li>
            <li>・ 連絡先に登録できる件数は最大1000件です。</li>
          </template>
          <template v-if="btnText === '登録' && selectedFormat === 'outlookExport'">
            <a-text
              class="t-phone-book-add-by-uploading-file__description"
              text="Outlookからエクスポートした連絡先CSVファイルをアップロードしてください。"
            />
            <li>・ 姓、名、フリガナ（姓）、フリガナ（名）、電話番号は必須項目となります。</li>
            <li>
              ・ 電話番号には優先順位があります。以下の左から優先度が高く登録されます。
              <br />　勤務先電話、携帯電話、自宅電話、勤務先電話2、勤務先代表電話、通常の電話、自宅電話2、自動車電話、無線電話、秘書の電話
              <br />　複数の電話番号が設定された場合、優先度が高いものが有効となります。
            </li>
            <li>・ 連絡先に登録できる件数は最大1000件です。</li>
          </template>
          <template v-else-if="btnText === '削除' && selectedFormat === 'simpleCsv'">
            <a-text
              class="t-phone-book-add-by-uploading-file__description"
              text="下のボタンからダウンロードしたテンプレートCSVファイルに削除したい連絡先情報を入力してアップロードしてください。"
            />
            <list>
              <li>・ 電話番号は必須項目となります。電話番号が合致した連絡先情報を削除します。</li>
              <li>・ 一度に削除できる件数は最大1000件です。</li>
            </list>
          </template>
          <template v-else-if="btnText === '削除' && selectedFormat === 'outlookExport'">
            <a-text
              class="t-phone-book-add-by-uploading-file__description"
              text="Outlookからエクスポートした連絡先CSVファイルをアップロードしてください。"
            />
            <li>・ 一度に削除できるのは最大1000件です。</li>
            <li>
              ・ 電話番号は必須項目となります。電話番号が合致した連絡先情報を削除します。
              <br />※1行に複数の電話番号が設定された場合は、一番優先度が高い電話番号に合致した連絡先が削除対象となります。
              <br />　以下の左から優先度が高くなります。
              <br />　勤務先電話、携帯電話、自宅電話、勤務先電話2、勤務先代表電話、通常の電話、自宅電話2、その他の電話、自動車電話、無線電話、秘書の電話
            </li>
          </template>

          <a-upload-field
            id="uploadArea"
            v-model="file"
            class="t-phone-book-add-by-uploading-file__form-upload"
            label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
            accept=".csv,.CSV"
            @change="handleUploadFileChange"
          />
          <div class="t-phone-book-add-by-uploading-file__template">
            <template v-if="selectedFormat === 'simpleCsv'">
              <a-button
                id="downloadButton"
                variant="text"
                :inline="true"
                color="primary"
                icon="download"
                label="テンプレートをダウンロード"
                :href="templateUrl"
                @click="handleTemplateDownloadClick"
              />
            </template>
          </div>
          <m-form-action-buttons>
            <a-button
              id="registButton"
              variant="block"
              color="primary"
              submit="submit"
              :disabled="!flagRegistButtonEnable"
            >
              {{ btnText }}
            </a-button>
            <a-button id="cancelButton" variant="outlined" color="primary" @click="handleCancelClick">
              キャンセル
            </a-button>
          </m-form-action-buttons>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="phoneBookAddUpload_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="dialogOkButton"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import AUploadField from '@/components/atoms/upload-field';
import ACaptionList from '@/components/atoms/caption-list';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MSection from '@/components/molecules/section';
import { cloneDeep } from 'lodash';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { POINT } from '@/libs/constants';

export default {
  name: 't-phone-book-add-by-uploading-file',
  components: {
    AText,
    AButton,
    APageHeading,
    AUploadField,
    //ACaptionList, ※使わなくなったのでコメントアウト
    MActionCard,
    MFormActionButtons,
    MSection,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    templateUrl: {
      type: String,
      default: '#',
    },
    companyID: {
      type: String,
      default: '',
    },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleSaveClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      file: null,
      binary: null,
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      flagRegistButtonEnable: true, //#1892
      titleText: '一括登録',
      btnText: '登録',
      authInfo: this.$store.state.user.authInfo,
      POINT,
      selectedFormat: 'simpleCsv',
      pulldownList: [
        { value: 'simpleCsv', label: 'CSVファイルによる一括登録' },
        { value: 'outlookExport', label: 'OutlookからエクスポートしたCSVファイルによる一括登録' },
      ],
      saveSuccessFlag: false, // 保存成功フラグ
    };

    function newFunction() {
      return 'id';
    }
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-phone-book-add-by-uploading-file');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    //#1892
    this.flagRegistButtonEnable = true; //#1892

    if (this.$route.query.csvType === 'del') {
      this.titleText = '一括削除';
      this.btnText = '削除';
      this.pulldownList = [
        { value: 'simpleCsv', label: 'CSVファイルによる一括削除' },
        { value: 'outlookExport', label: 'OutlookからエクスポートしたCSVファイルによる一括削除' },
      ];
    }
    if ((this.companyID !== POINT && this.authInfo === 'operator') || this.companyID === POINT) {
      // 権限がない(003300以外のオペレータ, または003300)の場合、一括登録不可
      this.$router.push({ path: '/permission-denied' });
    } else {
      //#1892
      this.flagRegistButtonEnable = true; //#1892
    }
  },

  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (this.saveSuccessFlag) {
        // 正常保存の場合、ユーザ管理画面に遷移
        this.handleCancelClick();
      }
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = false;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      // 登録するor削除するデータがない場合は画面遷移しない
      if (
        message !== messageContent.noticeNoPhoneBookRegisterd &&
        message !== messageContent.noticeNoPhoneBookDeleted
      ) {
        this.saveSuccessFlag = true;
      }
    },
    handleUploadFileChange(file) {
      const vm = this;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function () {
          const [info, content] = reader.result.split(',');
          vm.binary = content;
        },
        false
      );

      if (file[0]) {
        vm.filename = file[0].name;
        vm.size = file[0].size;
        reader.readAsDataURL(file[0]);
      } else {
        // clear file content
        vm.file = null;
        vm.binary = null;
        vm.filename = undefined;
        vm.size = undefined;
      }
    },
    handleFormSubmit(e) {
      // e.preventDefault();
      this.flagRegistButtonEnable = false; //#1892
      const payload = cloneDeep({
        filename: this.filename,
        binary: this.binary,
        size: this.size,
      });

      if (this.$route.query.csvType === 'del') {
        this.handleDelClick(payload);
      } else {
        this.handleSaveClick(payload);
      }
    },
    handleSaveClick(payload) {
      this.postRequest('/contactlist/batch', {
        companyID: this.selectedCompanyID,
        payload: payload,
        selectedPulldown: this.selectedFormat,
      })
        .then(e => {
          if (e.status === 'failed') {
            this.showErrorModal(e.msg);
          } else {
            this.showInfoModal(e.msg);
          }
          this.flagRegistButtonEnable = true; //#1892
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('一括登録'));
          this.flagRegistButtonEnable = true; //#1892
        });
    },
    handleDelClick(payload) {
      this.postRequest('/contactlist/batch', {
        companyID: this.selectedCompanyID,
        payload: payload,
        csvType: this.$route.query.csvType,
        selectedPulldown: this.selectedFormat,
      })
        .then(e => {
          if (e.status === 'failed') {
            this.showErrorModal(e.msg);
          } else {
            this.showInfoModal(e.msg);
          }
          this.flagRegistButtonEnable = true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('一括削除'));
          this.flagRegistButtonEnable = true;
        });
    },
    handleCancelClick() {
      this.$router.push({
        path: '/contactlist',
        query: { wordFlag: this.$route.query.wordFlag, searchFormType: this.$route.query.searchFormType },
      }); // #2121
    },
    onDrop(event) {
      const files = event.dataTransfer.files;
      this.file = files;
      // this.handleUploadFileChange(files);
      // if (files.length !== 1) {
      //   this.showErrorModal('ドラッグアンドドロップ失敗');
      //   return;
      // }
      // // if (files.length !== 1 || files[0].type.indexOf('image') !== 0) {
      // //   return;
      // // }
      // //TODO ファイルの読み込み処理
      // // this.handleUploadFileChange(files[0]);
      // // console.log(files.item(0));
      // this.file = files.item(0);
    },
    handleTemplateDownloadClick() {
      this.postRequest('/contactlist/template')
        .then(e => {
          const blob = new Blob([e.data], { type: 'text/plain' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.download = 'template.csv';
          a.href = url;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('テンプレートファイル取得'));
        });
    },
  },
};
</script>
